// extracted by mini-css-extract-plugin
export default {"warningIcon":"IUUStatus_warningIcon__AUq6c"};